export default function createPublicPathReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'CREATE_PUBLIC_PATH_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'CREATE_PUBLIC_PATH_ERROR':
            return {...state, ...{error: action.error}};

        case 'CREATE_PUBLIC_PATH_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}